import type { JSONSchemaType } from 'ajv'
import type { ActionDefinition, ActionOutcome } from '../action'
import { getAction, registerAction } from '../registry'

export const EXPLORE_PREVIEW_ACTION_ID = 'explore.preview.open'

type ExplorePreviewArgs = { intentText: string }
export type ExplorePreviewResult = { toastMessage: string }

const explorePreviewArgsSchema: JSONSchemaType<ExplorePreviewArgs> = {
  type: 'object',
  properties: { intentText: { type: 'string' } },
  required: ['intentText'],
  additionalProperties: false,
}

const isWorkspacePreview = (intentText: string): boolean => /\b(?:demo|public\s+workspace)\b/i.test(intentText)

const explorePreviewAction: ActionDefinition<ExplorePreviewArgs, ExplorePreviewResult> = {
  id: EXPLORE_PREVIEW_ACTION_ID,
  label: 'Open Explore preview',
  description: 'Opens Explore or the public workspace gallery.',
  risk: 'READ_ONLY',
  domain: 'explore',
  surfaces: ['ai', 'catalog'],
  argsSchema: explorePreviewArgsSchema,
  run: async ({ intentText }, context): Promise<ActionOutcome<ExplorePreviewResult>> => {
    const workspacePreview = isWorkspacePreview(intentText)
    const message = workspacePreview ? 'Opening public workspaces in Explore.' : 'Opening Explore.'
    return {
      kind: 'COMPLETED',
      result: { toastMessage: message.replace(/\.$/, '') },
      message,
      navigateTo: workspacePreview ? '/console/explore/workspaces' : '/console/explore',
      correlationId: context.correlationId!,
    }
  },
}

export const registerExplorePreviewAction = (): void => {
  if (!getAction(EXPLORE_PREVIEW_ACTION_ID)) registerAction(explorePreviewAction)
}

registerExplorePreviewAction()
